'use client';

import { Button } from '@/components/ui/button';
import { useLanguage } from '@/lib/i18n/LanguageContext';

interface TicketCheckoutFooterProps {
  totalPrice: number;
  hasSelection: boolean;
  onConfirm: () => void;
}

export default function TicketCheckoutFooter({
  totalPrice,
  hasSelection,
  onConfirm,
}: TicketCheckoutFooterProps) {
  const { t } = useLanguage();

  return (
    <div className="flex-shrink-0 border-t border-gray-200 p-4 sm:p-6 bg-white rounded-b-none sm:rounded-b-lg">
      {totalPrice > 0 && (
        <div className="flex items-center justify-between mb-4">
          <span className="text-lg font-semibold text-gray-900">{t('event.registration.total')}</span>
          <span className="text-3xl font-bold text-blue-600">₴{totalPrice.toFixed(2)}</span>
        </div>
      )}
      <Button
        onClick={onConfirm}
        disabled={!hasSelection}
        className="w-full"
      >
        {totalPrice === 0 && hasSelection
          ? t('event.registration.finishRegistration')
          : t('event.registration.proceedToCheckout')}
      </Button>
    </div>
  );
}
